import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from './authentication.service';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';


@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private authService: AuthenticationService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isAuthenticated()) {
        return true;
    }
    else
      this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// /Users/igor/Projects/onechat/admin-dashboard/src/app/authentication/auth-guard.service.ts